import request from '@/utils/request'

export function selectOther(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/otherSet/selectOther?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateOther(data) {
    return request({
        url: `api/serviceCenter/otherSet/upDateOther`,
        method: 'post',
        data,
    })
}
export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/otherSet/bathDeleteFile`,
        method: 'post',
        data,
    })
}

export function addOther(data) {
    return request({
        url: `api/serviceCenter/otherSet/addOther`,
        method: 'post',
        data,
    })
}

export function selectOtherName(data) {
    return request({
        url: `api/serviceCenter/setPanel/selectPanelName?access=${data}`,
        method: 'post',
    })
}
